import React from 'react';
import { InitialModal } from 'src/components/selfService/features/OrderHistory/ZipDownload/modals/InitialModal';

import {
  ZipFileStatus,
  ZipFileFilters,
} from 'src/components/selfService/features/OrderHistory/ZipDownload/ZipDownload.utils';
import { DownloadCompleteModal } from './DownloadCompleteModal';
import { InProgressModal } from './InProgressModal';
import { DownloadFailedModal } from './DownloadFailedModal';
import { TooManyReceiptsModal } from './TooManyReceiptsModal';

export interface IModalsZipControllerProps {
  status: ZipFileStatus;
  maximumReceiptsAllowed: number;
  isOpen: boolean;
  onClose: () => void;
  onStartGeneration: () => void;
  onResetGeneration: () => void;
  filters: ZipFileFilters;
  onDownloadAgain: () => void;
  totalReceipts: number;
}

export function ModalsZipController({
  status,
  maximumReceiptsAllowed,
  isOpen,
  onClose,
  onStartGeneration,
  onResetGeneration,
  filters,
  onDownloadAgain,
  totalReceipts,
}: IModalsZipControllerProps): JSX.Element {
  if (!isOpen) {
    return <></>;
  }

  switch (status) {
    case ZipFileStatus.GENERATE:
      return (
        <InitialModal
          totalReceiptsToGenerate={totalReceipts}
          filters={filters}
          onClose={onClose}
          onStartGeneration={onStartGeneration}
        />
      );
    case ZipFileStatus.FETCHING:
    case ZipFileStatus.COMPLETE:
      return <InProgressModal onClose={onClose} />;

    case ZipFileStatus.DOWNLOAD_SUCCESSFULLY:
      return (
        <DownloadCompleteModal
          onClose={onResetGeneration}
          onDownloadAgain={onDownloadAgain}
        />
      );

    case ZipFileStatus.DOWNLOAD_FAILED:
      return (
        <DownloadFailedModal filters={filters} onClose={onResetGeneration} />
      );

    case ZipFileStatus.TOO_MANY:
      return (
        <TooManyReceiptsModal
          maximumReceiptsAllowed={maximumReceiptsAllowed}
          filters={filters}
          onClose={onResetGeneration}
        />
      );
    default:
      return <></>;
  }
}
